module.exports = __webpack_public_path__ + "img/20200509145341751.25bcef0b.png";